import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { UseTypeFontSize } from '../hooks/useTypeFontSize'

export const MaxSizeItem = ({ children, keyItem, setSizes, size }) => {
  const ref = useRef()
  const locale = useSelector((state) => state.i18n.locale)
  const typeFontSize = UseTypeFontSize()

  useEffect(() => {
    let timeOut = null
    if (ref.current) {
      timeOut = setTimeout(() => {
        setSizes((sizes) => ({
          ...sizes,
          [keyItem]: {
            width: ref.current.getBoundingClientRect().width,
            height: ref.current.getBoundingClientRect().height,
          },
        }))
      }, 100)
    }

    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
        timeOut = null
      }
    }
  }, [locale, typeFontSize])

  return (
    <>
      <div style={{ width: size.width }}>{size.width ? children : null}</div>
      <div ref={ref} style={{ position: 'absolute', top: -9999 }}>
        {children}
      </div>
    </>
  )
}

MaxSizeItem.propTypes = {
  children: PropTypes.node.isRequired,
  keyItem: PropTypes.string.isRequired,
  setSizes: PropTypes.func.isRequired,
  size: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
}
